import React, { Suspense, lazy, useEffect, useState } from 'react';
import PropTypes from "prop-types";
import withRouter from '../Components/Common/withRouter';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';


//import Components
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import RightSidebar from '../Components/Common/RightSidebar';

//import actions
import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changeSidebarVisibility
} from "../slices/thunks";

// Lazy so the shell's Tailwind CSS only loads on affiliate dashboard routes
const AffiliateDashboardShell = lazy(() => import('../pages/affiliate/dashboard/_components/AffiliateDashboardShell'));

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import { PARTNER_PORTAL_PATH } from '../pages/affiliate/partnerAccount';


const Layout = (props:any) => {
    const location = useLocation();
    const dispatch = useDispatch<any>();
    const selectLayoutProperties = createSelector(
        (state:any) => state.Layout,
        (layout) => ({
            layoutType: layout.layoutType,
            leftSidebarType: layout.leftSidebarType,
            layoutModeType: layout.layoutModeType,
            layoutWidthType: layout.layoutWidthType,
            layoutPositionType: layout.layoutPositionType,
            topbarThemeType: layout.topbarThemeType,
            leftsidbarSizeType: layout.leftsidbarSizeType,
            leftSidebarViewType: layout.leftSidebarViewType,
            leftSidebarImageType: layout.leftSidebarImageType,
            preloader: layout.preloader,
            sidebarVisibilitytype: layout.sidebarVisibilitytype,
        })
    );
    // Inside your component
    const {
        layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype
    } = useSelector(selectLayoutProperties);

    const affiliateDashboardRoutes = ['/affiliate/dashboard', '/affiliate/report', '/affiliate/commission', '/affiliate/history', '/affiliate/link', '/affiliate/profile'];
    const isAffiliateDashboard = affiliateDashboardRoutes.some((route) => location.pathname === route);
    const isAffiliateDemo = location.pathname.startsWith(PARTNER_PORTAL_PATH);
    
    // Check if current path is /onboarding
    const isOnboarding = location.pathname.startsWith('/onboarding');


    /*
    layout settings
    */
    useEffect(() => {
        if (
            layoutType ||
            leftSidebarType ||
            layoutModeType ||
            layoutWidthType ||
            layoutPositionType ||
            topbarThemeType ||
            leftsidbarSizeType ||
            leftSidebarViewType ||
            leftSidebarImageType ||
            sidebarVisibilitytype
        ) {
            window.dispatchEvent(new Event('resize'));
            dispatch(changeLeftsidebarViewType(leftSidebarViewType));
            dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
            dispatch(changeSidebarTheme(leftSidebarType));
            dispatch(changeLayoutMode(layoutModeType));
            dispatch(changeLayoutWidth(layoutWidthType));
            dispatch(changeLayoutPosition(layoutPositionType));
            dispatch(changeTopbarTheme(topbarThemeType));
            dispatch(changeLayout(layoutType));
            dispatch(changeSidebarImageType(leftSidebarImageType));
            dispatch(changeSidebarVisibility(sidebarVisibilitytype));
        }
    }, [layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype,
        dispatch]);
    /*
    call dark/light mode
    */
    const onChangeLayoutMode = (value:any) => {
        if (changeLayoutMode) {
            dispatch(changeLayoutMode(value));
        }
    };

    const [headerClass, setHeaderClass] = useState("");
    // class add remove in header
    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
    });
    function scrollNavigation() {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setHeaderClass("topbar-shadow");
        } else {
            setHeaderClass("");
        }
    }

    useEffect(() => {
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        if (humberIcon) {
            if (sidebarVisibilitytype === 'show' || layoutType === "vertical" || layoutType === "twocolumn") {
                humberIcon.classList.remove('open');
            } else {
                humberIcon.classList.add('open');
            }
        }
    }, [sidebarVisibilitytype, layoutType]);

    return (
        <React.Fragment>
            <div id="layout-wrapper" className={isAffiliateDashboard || isAffiliateDemo ? "affiliate-layout" : undefined}>
                {isAffiliateDashboard ? (
                    <Suspense fallback={null}>
                        <AffiliateDashboardShell>{props.children}</AffiliateDashboardShell>
                    </Suspense>
                ) : (
                    <>
                        {!isAffiliateDemo && !isOnboarding && (
                            <Header
                                headerClass={headerClass}
                                layoutModeType={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode} />
                        )}
                        {!isAffiliateDemo && !isOnboarding && <Sidebar layoutType={layoutType} />}
                        {!isAffiliateDemo && <div className="main-content">{props.children}</div>}
                        { !isOnboarding && !isAffiliateDemo && <Footer /> }
                        {isAffiliateDemo && props.children}
                    </>
                )}
            </div>
            {/**
            <RightSidebar />
            */}
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </React.Fragment>

    );
};

Layout.propTypes = {
    children: PropTypes.object,
};

export default withRouter(Layout);
